import React, { useEffect, useState } from "react";
import "../../_css/ReviewAns.css";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { notifyError, notifySuccess } from "../helper/Toaster";
import { getOneAns, updateaiEval } from "../../requests";
import { useRef } from "react";

const AIEval = ({ fn, view, id, setRefresh, refresh }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState("");
  const [obtMarks, setObtMarks] = useState("");
  const [remarks, setRemarks] = useState("");
  const inputRef = useRef(null);

  const handleWheel = (e) => {
    e.preventDefault(); // stop scroll changing value
  };

  const handleSave = async () => {
    if (obtMarks > data.marks) {
      notifyError("Please enter marks less than maximum marks");
      return;
    }

    dispatch(startLoader());
    try {
      const res = await updateaiEval({
        id: data.id,
        obt_marks: obtMarks,
        remarks: remarks,
      });

      if (res.status < 400) {
        // setObtMarks("")

        notifySuccess("Data updated successfully");
        setRefresh((p) => !p)
        // window.location.reload()
      }
    } catch (error) {
      notifyError("Server busy try again");
    } finally {
      dispatch(stopLoader());
    }
  };

  const get_answer_sheet = async () => {
    dispatch(startLoader());
    try {
      const res = await getOneAns(id);
      setData(res.data.data);
      setRemarks(res.data.data.remarks);
    } catch (error) {
      notifyError("Something went wrong");
      console.log(error);
    } finally {
      dispatch(stopLoader());
    }
  };

  useEffect(() => {
    get_answer_sheet();
    setObtMarks("")
  }, [id, refresh]);

  return (
    <div className="ai-eval-con">
      <div className="ai-eval-head di-flex">
        <span>AI Evaluation</span>
        <img
          src="/close.svg"
          width="14px"
          height="14px"
          className="pe-cursor"
          onClick={() => fn()}
        />
      </div>

      {/* Question metadata - NEW for API v3.3 */}
      {(data?.question_type || data?.evaluated_by || data?.low_confidence_flag) && (
        <div className="ai-eval-metadata">
          {data.question_type && (
            <div className="metadata-item">
              <span className="metadata-label">Type:</span>
              <span className="metadata-badge metadata-type">
                {data.question_type}
              </span>
            </div>
          )}
          {data.evaluated_by === 'vision' && (
            <div className="metadata-item">
              <span className="metadata-badge metadata-vision">
                Evaluated by Vision AI
              </span>
            </div>
          )}
          {data.low_confidence_flag && (
            <>
              <div className="metadata-item metadata-warning">
                <span className="metadata-badge metadata-low-confidence">
                  ⚠️ Low Confidence
                </span>
                {data.confidence !== undefined && (
                  <span className="metadata-confidence-score">
                    {(data.confidence * 100).toFixed(0)}% confident
                  </span>
                )}

              </div>
              {data.low_confidence_reason && (
                <div className="low-confidence-reason">
                  <strong>Reason:</strong> {data.low_confidence_reason}
                </div>
              )}
            </>
          )}
        </div>
      )}

      <div className="ai-eval-form">
        <label className="ai-eval-label">AI Marks</label>
        <input className="ai-eval-input" value={data?.obt_marks} readOnly />
      </div>
      <div className="ai-eval-form">
        <label className="ai-eval-label">Teacher Override</label>
        <input
          ref={inputRef}
          style={{ backgroundColor: "#FFFFFF", border: "1px solid #F1F1F5" }}
          className="ai-eval-input no-spinner"
          type="number"
          onFocus={() => {
            inputRef.current.addEventListener("wheel", handleWheel, {
              passive: false,
            });
          }}
          onBlur={() => {
            inputRef.current.removeEventListener("wheel", handleWheel);
          }}
          value={obtMarks}
          onChange={(e) => setObtMarks(e.target.value)}
          placeholder="Enter marks"
        />
      </div>
      <div className="ai-eval-form">
        <label className="ai-eval-label">Reference answer</label>
        <textarea
          rows={4}
          className="ai-eval-input"
          defaultValue={data.actual_answer}
          readOnly
        ></textarea>
      </div>
      <div className="ai-eval-form">
        <label className="ai-eval-label">AI Feedback</label>
        <textarea
          rows={4}
          className="ai-eval-input"
          defaultValue={data.ai_feedback}
          readOnly

        ></textarea>
      </div>
      <div className="ai-eval-form">
        <label className="ai-eval-label">Add Note</label>
        <input
          type="text"
          style={{ backgroundColor: "#FFFFFF", border: "1px solid #F1F1F5" }}
          className="ai-eval-input"
          placeholder="Remarks"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />
      </div>

      <button className="ai-eval-btn" onClick={handleSave}>
        Save
      </button>
    </div>
  );
};

export default AIEval;
